import './KPICard.css';

function deltaIcon(direction) {
  if (direction === 'up') return '▲';
  if (direction === 'down') return '▼';
  return '–';
}

export function KPICard({ label, value, delta, deltaDirection, hint, icon, accentColor, onClick }) {
  const style = accentColor ? { '--kpi-accent': accentColor } : undefined;
  const clickable = typeof onClick === 'function';
  const clickProps = clickable
    ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); } },
      }
    : {};
  return (
    <div className={`ui-kpi-card${clickable ? ' ui-kpi-card--clickable' : ''}`} style={style} {...clickProps}>
      <div className="ui-kpi-top">
        <span className="ui-kpi-label" title={label}>{label}</span>
        {icon && <div className="ui-kpi-icon" aria-hidden="true">{icon}</div>}
      </div>
      <div className="ui-kpi-value">{value}</div>
      {(delta != null || hint) && (
        <div className="ui-kpi-foot">
          {delta != null && (
            <span className={`ui-kpi-delta ui-kpi-delta--${deltaDirection || 'flat'}`}>
              <span aria-hidden="true">{deltaIcon(deltaDirection)}</span>
              {delta}
            </span>
          )}
          {hint && <span className="ui-kpi-hint">{hint}</span>}
        </div>
      )}
    </div>
  );
}
